/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSendCompanyDocsMessageResponseFromDiscriminatorValue, serializeSendCompanyDocsMessageRequest, serializeSendCompanyDocsMessageResponse, type ErrorResponse, type InternalErrorResponse, type SendCompanyDocsMessageRequest, type SendCompanyDocsMessageResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/messagecenter/companydocs/send
 */
export interface SendRequestBuilder extends BaseRequestBuilder<SendRequestBuilder> {
    /**
     * Sends company documents with custom subject and body to specified recipients via email and/or SMS. Documents are included as download links with a view online option.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SendCompanyDocsMessageResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 401 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: SendCompanyDocsMessageRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SendCompanyDocsMessageResponse | undefined>;
    /**
     * Sends company documents with custom subject and body to specified recipients via email and/or SMS. Documents are included as download links with a view online option.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SendCompanyDocsMessageRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SendRequestBuilderUriTemplate = "{+baseurl}/api/messagecenter/companydocs/send";
/**
 * Metadata for all the requests in the request builder.
 */
export const SendRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: SendRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSendCompanyDocsMessageResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSendCompanyDocsMessageRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
